if (process.client) {
  require("core-js")
}
